<template>
  <div>
    <!--头部-->
    <div class="filter-header">
      <!--首页已签约钻取进入已签约页面-->
      <i class="icon-fanhui icon iconfont"
         @click="returnPage"></i>
      <!--默认选择全部区域-->
      <span class="area">{{c_item=='0'?'全部':getCurrentItem()}}</span>
      <span class="time">{{begin_time}}-{{end_time}}</span>
      <i class="icon iconfont icon-shaixuan"
         @click="filter"></i>
    </div>

    <!--</ul>-->
    <!--新增签约金额占比饼图，将其移动至已签约钻取页面顶部 周二新增-->
    <div v-if="type == 1">
      <div class="percent1">
        <p class="test">
          各小组{{begin_time}}-{{end_time}}回款金额占比(万)
        </p>
        <!--小组回款排名占比饼图-->
        <IEcharts :option="pie" style="position:relative;top:0.8rem;"></IEcharts>
      </div>
    </div>
    <div v-if="type==2">
      <div class="percent1">
        <p class="test">
          各小组{{begin_time}}-{{end_time}}签约金额占比(万)
        </p>
        <!--小组销售排名占比饼图-->
        <IEcharts :option="pie2"  style="position:relative;top:0.5rem;"></IEcharts>
      </div>
    </div>
    <!--详情-->
    <div class="list-wrapper">

      <div class="list-item"
           v-for=" (item,index) in allData"
           :key="index">
        <div class="row text">
          <span v-if="type==1||type==2"></span>
          <span v-if="type==1">{{ item.region_name}}</span>
          <span v-if="type==2">{{ item.region}}</span>
        </div>
        <div class="row text">
          <!-- <span >{{ item.name }}</span> -->
          <span v-if="type == 1 "> <span class="title">最后回款时间</span>{{ item.last_updated }}</span>
          <span v-else>
            <span v-if="type == 2">
              签约时间: {{ item.reviewed_at == undefined ? '' : item.reviewed_at.slice(0,10) }}
            </span>
            <span v-if="type == 1">
              回款时间: {{ item.last_updated == undefined ? '' : item.last_updated.slice(0,10) }}
            </span>
          </span>
          <span v-if="type==1">{{ item.group_name }}</span>
          <span v-if="type==2">{{ item.group_name }}</span>

        </div>

        <div class="row text">
          <!-- <span v-if="type==1"
                @click='GoProdetail(item.project_id)'>{{ item.p_name }}</span>
          <span v-else
                @click='GoProdetail(item.project_id)'>{{ item.p_name }}</span> -->
           <span v-if="type==2">{{ item.name }}</span>
          <span v-else>{{ item.p_name }}</span>
          <div class="row-item"
               v-if="type==1">
            <span><span class="title">负责人</span>{{ item.sales }}</span>
          </div>
          <!-- <span v-if="type==6">{{ item.group_name }}</span> -->
          <span>{{ status[item.status] }}</span>
        </div>
        <!--钻取-->
        <div class="row"
             v-if="type==2">
          <div class="row-item">
            <p class="item-value"> <span class="symbol">¥</span>{{ origin == 1 ? (item.b_money/10000).toFixed(2) : (item.b_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
            <p class="item-name">已回款金额</p>
          </div>
          <div class="row-item center">
            <p class="item-value"> <span class="symbol">¥</span> {{ origin == 1 ? (item.p_money/10000).toFixed(2) : (item.p_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
            <p class="item-name">项目金额</p>
          </div>
          <div class="row-item">
            <p class="item-value charge"> {{item.sales}} </p>
            <p class="item-name">负责人</p>
          </div>
        </div>
        <div class="row"
             v-if="type==1">
          <div class="row-item">
            <p class="item-value"> <span class="symbol">¥</span>{{ origin == 1 ? (item.bc_money/10000).toFixed(2) : (item.bc_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
            <p class="item-name">本期回款额</p>
          </div>
          <div class="row-item center">
            <p class="item-value"> <span class="symbol">¥</span>{{ origin == 1 ? (item.b_money/10000).toFixed(2) : (item.b_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
            <p class="item-name">总回款额</p>
          </div>
          <div class="row-item">
            <p class="item-value "> <span class="symbol">¥</span> {{ origin == 1 ? (item.p_money/10000).toFixed(2) : (item.p_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
            <p class="item-name">项目金额</p>
          </div>

        </div>
      </div>
      <!--如果获取不到数据，显示暂无数据-->
      <nodata v-if="!allData.length"></nodata>
    </div>
    <div class="zhezhao"
         v-if="isFilter"
         @click="cancel"></div>

    <!--筛选-->
    <div class="selbox"
         v-if="isFilter">
      <p>筛选</p>
      <p class="content">
        时间
      </p>
      <ul class="listtime">
        <!--显示3条时间-->
        <mt-picker :slots="slots"
                   @change="onDateChange"
                   valueKey="name"
                   class="inner-picker"
                   :visibleItemCount="3"></mt-picker>
      </ul>
      <p class="content">
         小组
       </p>
        <ul  class="listtime">
         <li  style="font-size:12px;width: 3rem; margin-right:0.3rem;" :class="{'isactive': c_item== item.id}" v-for="item in itemList" @click="onItemChange(item.id)" :key="item.id" >{{item.name}}</li>
       </ul>

      <p class="btnyes"
         @click="confirmFilter">确定</p>
    </div>

  </div>
</template>

<script>
  //新增图表
  import IEcharts from 'vue-echarts-v3/src/lite.js'//引入图表插件
  import 'echarts/lib/component/legend'
  import 'echarts/lib/chart/bar'//
  import 'echarts/lib/chart/pie'//饼图
  import 'echarts/lib/component/title'//标题

  import Vue from 'vue'
  //完成图表引入
  import nodata from '../public/nodata'
  import '../../assets/css/drillStyle.css'
  import slotsList from '../../assets/js/slotsList'
  import dateChange from '../../mixins/dateChange.js'
  import regionChange from '../../mixins/regionChange.js'


  export default {
    mixins: [dateChange, regionChange],
    components: {
      nodata,
      IEcharts,
    },
    data () {
      return {
        status: {
          0: '待处理',
          1: '开发中',
          2: '已交付',
          3: '已暂停',
          4: '已关闭',
          5: '已完结',
        }, //状态
        pie: { //各区域签约金额占比
          // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
          legend: {
            width: '60%',
            bottom: '3%',
            icon: 'circle',
            data: [],
            itemGap: 20,
            textStyle: {
              fontSize: 12,
              color: '#333',
            }
          },
          title: [{
            text: '回款总金额',
            x: '49%',
            y: '39%',
            textAlign: 'center',
            textStyle: {
              color: '#333',
              fontSize: '12',
              fontWeight: '400',
            }
          },
          {
            text: '',
            x: '49%',
            y: '45%',
            textAlign: 'center',
            textStyle: {
              color: '#333',
              fontSize: '12',
              fontWeight: '400',
            }
          }],
          series: [{
            center: ['50%', '45%'],
            color: ['#6DB0FB', '#EC7A8A', '#FAE35A', '#D185FF', '#FFA761', '#86E687'],
            hoverAnimation: false, //设置饼图默认的展开样式
            radius: [40, 60],
            name: 'pie',
            type: 'pie',
            selectedMode: 'single',
            selectedOffset: 6, //选中是扇区偏移量
            clockwise: true,
            startAngle: 90,
            //data: [{value:100,name:'北京'},{value:200,name:'上海'},{value:150,name:'深圳'},{value:200,name:'珠海'},{value:100,name:'三亚'},{value:100,name:'成都'}],
            data: [],
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: "{d}%\n{b} {c}万",
                textStyle: {
                  fontSize: 10,
                }
              }
            }
          }]
        },
        pie2: { //各区域回款金额占比
          // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
          legend: {
            width: '60%',
            bottom: '3%',
            icon: 'circle',
            data: [],
            itemGap: 20,
            textStyle: {
              fontSize: 12,
              color: '#333',
            }
          },
          title: [{
            text: '签约总金额',
            x: '49%',
            y: '39%',
            textAlign: 'center',
            textStyle: {
              color: '#333',
              fontSize: '12',
              fontWeight: '400',
            }
          },
          {
            text: '',
            x: '49%',
            y: '45%',
            textAlign: 'center',
            textStyle: {
              color: '#333',
              fontSize: '12',
              fontWeight: '400',
            }
          }],
          series: [{
            center: ['50%', '45%'],
            color: ['#6DB0FB', '#EC7A8A', '#FAE35A', '#D185FF', '#FFA761', '#86E687'],
            hoverAnimation: false, //设置饼图默认的展开样式
            radius: [40, 60],//里面的圆角配置项
            name: 'pie',//名称
            type: 'pie',//类型
            selectedMode: 'single',
            selectedOffset: 6, //选中是扇区偏移量
            clockwise: true,
            startAngle: 90,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: "{d}%\n{b} {c}万",
                textStyle: {
                  fontSize: 10,
                }
              }
            }
          }]
        },
        isFilter: false,
        begin_time: null,
        end_time: null,
        origin: null, //1:首页 2:分析页
        type: '', // 1:签约 2:回款
        allData:[],
        data: { //总体数据
          data: [],
        }

      }
    },

    methods: {
      returnPage () {
        this.$router.go(-1)
      },
      getData (data) {
        this.$notice.loading()
        if (this.type == 1) {//type为1，获取已签约页面数据，
          this.$http.getItems(data).then(res => {
            // this.data = res.data
            this.$notice.loading(false)
            this.pie.title[1].text = res.data.b_count.toFixed(2)
            this.pie.series[0].data = res.data.b_list
          })
           this.$http.getRegionBackDrill(data).then(res => {
            // this.data = res.data
            this.allData=res.data.data//总体数据
            this.$notice.loading(false)
          })

        }
        if (this.type == 2) {
          this.$http.getItems(data).then(res => {
            // this.data = res.data
            this.$notice.loading(false)
            //获取已回款占比
            this.pie2.title[1].text = res.data.t_count.toFixed(2)
            this.pie2.series[0].data = res.data.t_list
          })
            this.$http.getBusinessSignDrill(data).then(res => {
              // this.data = res.data
              this.allData=res.data.data
              this.$notice.loading(false)
            })

        }


      },

      filter () { //显示过滤
        this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
        this.isFilter = true
        this.$emit('inFilter')
      },

      confirmFilter () { //确定过滤
        this.begin_time = this.c_begin_time
        this.end_time = this.c_end_time
        // this.region = this.c_region
        let data = {
          begin_time: this.begin_time,
          end_time: this.end_time,
          // region: this.region,
          item: this.c_item
        }
        this.isFilter = false
        this.getData(data)
        this.$emit('noFilter')
      },

      cancel () { //点击阴影取消
        this.c_region = this.region
        this.isFilter = false
        this.$emit('noFilter')
      },
      GoProdetail (pid) {//项目详情页面
        // console.log(pid)
        this.$router.push({ name: 'prodetails', params: { project_id: pid } })
      },

    },
    created () {


      let data = JSON.parse(this.$route.query.itemData)
      let { type, begin_time, end_time, item } = data
      this.type = type
      this.begin_time = begin_time
      this.end_time = end_time
      this.item = item
      this.c_item=item

      this.getData(data)
    },
  }
</script>

<style scoped>
  /*排行抬头样式*/
  .listtime{
   margin-top: 0.3125rem;
   margin-left: 0.1875rem;
   margin-bottom: 0.1875rem;
 }
 .listtime1 li{
   width: 3rem;
   text-align: center;
   height: 0.84375rem;
   line-height: 0.84375rem;
   border-radius: 0.125rem;
   background: #F1F1F1;
   color: #333333;
   display: inline-block;
   font-size: 0.375rem;
   margin-right:0.3rem;
   margin-bottom: 0.1875rem;
 }
 .isactive {
    color: #5483d2;
    background: #c9ddfd;
  }
  .test {
    border-left: 0.0625rem solid #5483d2;
    width: 100%;
    position: absolute;
    right: 0;
    top: 0.34375rem;
    font-size: 0.375rem;
    color: #333333;
    font-family: PingFangSC-Regular;
    padding-left: 2%;
    font-weight: 500;
    line-height: 1.6;
  }
  .test span {
    position: absolute;
    right: 5%;
    font-family: PingFangSC-Regular;
    color: #5482d2;
    font-size: 0.375rem;
  }
  /*饼图样式*/
  .percent1 {
    color: #000;
    height: 6.5rem;
    position: relative;
    width: 100%;
    background: #fff;
    margin-bottom: 0.1875rem;
  }
  .percent1.ex {
    height: 8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/itemBackOrSale.vue